var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllcomicsQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillOpacity: 1,
      colorRendering: "auto",
      colorInterpolation: "auto",
      textRendering: "auto",
      stroke: "black",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      shapeRendering: "auto",
      strokeOpacity: 1,
      fill: "black",
      strokeDasharray: "none",
      fontWeight: "normal",
      strokeWidth: 1,
      fontFamily: "'Dialog'",
      fontStyle: "normal",
      strokeLinejoin: "miter",
      fontSize: 12,
      strokeDashoffset: 0,
      imageRendering: "auto"
    },
    width: 306,
    height: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "genericDefs"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "white",
      textRendering: "optimizeLegibility",
      stroke: "white"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 306,
    height: 306,
    y: 0,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 8,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 8,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 8,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 8,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 8,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 8,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 18,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 28,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 38,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 38,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 38,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 38,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 38,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 38,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 48,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 48,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 48,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 48,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 48,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 48,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 58,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 58,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 58,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 58,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 58,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 68,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 68,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 68,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 68,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 68,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 68,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 68,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 78,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 88,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 98,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 108,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 118,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 128,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 138,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 148,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 158,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 168,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 178,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 188,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 198,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 208,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 218,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 218,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 218,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 218,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 218,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 218,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 218,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 228,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 238,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 248,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 258,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 268,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 278,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 288,
    width: 10,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 70,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 50,
    height: 50,
    y: 18,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 30,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 8,
    width: 70,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    width: 50,
    height: 50,
    y: 18,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 28,
    width: 30,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 228,
    width: 70,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 50,
    height: 50,
    y: 238,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 248,
    width: 30,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 30
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllcomicsQr);
export default __webpack_public_path__ + "static/media/allcomics_QR.4f89bb1990234956f0c2cad297901f0d.svg";
export { ForwardRef as ReactComponent };